import React from 'react';
import { Link } from 'react-router-dom';
import { webAppConfig } from '../../config/appConfig';

type FooterProps = {
  className: string;
  variant?: 'default' | 'landing';
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
};

export default function Footer({ className, leftContent, rightContent }: Readonly<FooterProps>) {

  return (
    <footer className={`${className} site-footer`}>
      <div className="site-footer-shell">
        <div className="site-footer-grid">
          <div className="site-footer-column site-footer-company">
            {leftContent ? <div className="site-footer-extra">{leftContent}</div> : null}
          </div>

          <div className="site-footer-column">
            <h3>Platform</h3>
            <Link to={webAppConfig.routes.home}>Home</Link>
            <Link to={webAppConfig.routes.app}>Marketplace</Link>
          </div>

          <div className="site-footer-column">
            <h3>Legal</h3>
            <Link to={webAppConfig.routes.privacy}>Privacy Policy</Link>
          </div>

          <div className="site-footer-column">
            <h3>Company</h3>
            <span className="site-footer-note">Independent providers, not employees.</span>
            <span className="site-footer-note">Marketplace connections, not job guarantees.</span>
            {rightContent ? <div className="site-footer-extra">{rightContent}</div> : null}
          </div>
        </div>
      </div>
    </footer>
  );
}
